(function ($) {
	const $columnsWraps = $('.reverse-order-on-mob');
	let $column;
	let ticking = false;

	// store the columns' orders
	// this is the order for desktop
	$columnsWraps.each(setColumnsInitialOrder);

	function setColumnsInitialOrder() {
		const $columnsWrap = $(this);
		$columnsWrap.data('columns', $columnsWrap.find('> *'));
		$columnsWrap.data('collapsed', false);

		$columnsWrap.data('columns').each(function (index) {
			$(this).data('original-order', index);
		});
	}

	// reverse the order for mobile
	function reverseColumns($columnsWrap) {
		// reverse the order by moving the columns
		// do not use CSS order as it will not be a11y friendly
		// so remove each column and prepend it to the parent
		$columnsWrap.data('columns').each(function () {
			$column = $(this);
			$column.prependTo($columnsWrap);
		});
	}

	function restoreColumns($columnsWrap) {
		// restore the order by moving the columns
		// do not use CSS order as it will not be a11y friendly
		// so remove each column and append it to the parent
		// sort them by the original order
		$columnsWrap.data('columns').sort(function (a, b) {
			return $(a).data('original-order') - $(b).data('original-order');
		});

		$columnsWrap.data('columns').each(function () {
			$column = $(this);
			$column.appendTo($columnsWrap);
		});
	}

	function checkIfColumnsAreCollapsed($columnsWrap) {
		// this should be true if the columns have different rect top values
		// this means that the columns have been collapsed
		let collapsed = false;
		let rectTop;
		let firstRectTop;
		let differentRectTop = false;

		firstRectTop = $columnsWrap.data('columns').first()[0].getBoundingClientRect().top;
		$columnsWrap.data('columns').each(function () {
			rectTop = this.getBoundingClientRect().top;

			if (rectTop !== firstRectTop) {
				differentRectTop = true;
			}
		});

		if (differentRectTop) {
			collapsed = true;
		}

		return collapsed;
	}

	function checkColumnsOrder() {
		if (ticking) {
			return;
		}

		ticking = true;

		$columnsWraps.each(function () {
			const $columnsWrap = $(this);
			const shouldCollapse = checkIfColumnsAreCollapsed($columnsWrap);
			const isCollapsed = $columnsWrap.data('collapsed');

			if (shouldCollapse && !isCollapsed) {
				$columnsWrap.data('collapsed', true);
				reverseColumns($columnsWrap);
			} else if (!shouldCollapse && isCollapsed) {
				$columnsWrap.data('collapsed', false);
				restoreColumns($columnsWrap);
			}
		});

		ticking = false;
	}

	checkColumnsOrder();

	// check if the columns have been collapsed on resize, debounced (no lodash)
	let resizeTimer;
	$(window).on('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(checkColumnsOrder, 20);
	});
})(jQuery);
